export default __webpack_public_path__ + "svg/calendar/2026/0/marzo.svg?0c6afee8";